import React from 'react';
import { func, number, shape, string } from 'prop-types';

import Css from '@components/Partners/Mobile/ListBox.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Row, Col } from 'reactstrap';

const propTypes = {
  activeBoxId: number.isRequired,
  box: shape({
    content: string.isRequired,
    id: number.isRequired,
    title: string.isRequired
  }).isRequired,
  className: string.isRequired,
  onClick: func.isRequired,
  parentClassName: string
};

const defaultProps = {
  parentClassName: ''
};

const ListBox = ({ activeBoxId, box, className, parentClassName, onClick }) => {
  const { content, id, title, titleImg } = box;

  const headerClasses =
    parentClassName !== ''
      ? `${parentClassName} ${Css.box}`
      : `${Css.box} p-3 pl-4`;

  const contentClasses =
    activeBoxId === id ? `pt-3 pl-3 pr-3 d-block` : `d-none`;

  const contentDiv = (
    <div className={Css.items} dangerouslySetInnerHTML={{ __html: content }} />
  );

  return (
    <div className={' w-100 '} key={id}>
      <div className={headerClasses} onClick={onClick}>
        <Row>
          <Col xs={11}>
            <span className={Css.title + ' lakes-bold'}>{title}</span>
            {titleImg !== undefined && (
              <div
                className={'px-3 py-2 d-flex align-items-center'}
                style={{ height: '70px' }}
              >
                <img
                  src={titleImg.src}
                  alt={titleImg.alt}
                  className={'img-fluid d-block mx-auto'}
                  style={{ 'max-height': '100%' }}
                />
              </div>
            )}
          </Col>
          <Col xs={1} className={'d-flex align-items-center'}>
            {activeBoxId === id ? (
              <FontAwesomeIcon
                icon={['fas', 'minus']}
                className={'float-right mt-1'}
              />
            ) : (
              <FontAwesomeIcon
                icon={['fas', 'plus']}
                className={'float-right mt-1'}
              />
            )}
          </Col>
        </Row>
        <div className={contentClasses}>{activeBoxId === id && contentDiv}</div>
      </div>
    </div>
  );
};

ListBox.propTypes = propTypes;
ListBox.defaultProps = defaultProps;

export default ListBox;



// WEBPACK FOOTER //
// ./src/components/Partners/Mobile/ListBox.jsx